module.exports = __webpack_public_path__ + "img/vimeo_thumbnail_default.a314d86a.jpg";